import styled from 'styled-components'

import * as colors from '../../constants/colors.ts'

const DiscreetText = styled.span`
  font-size: 12px;
  font-weight: ${(props) => (props.light ? 300 : 400)};
  color: ${colors.TEXT_TERTIARY};
`

export default DiscreetText
